<div class="header--section" [ngClass]="sectionClasses()">
    <div class="-heading"><h3 [data-testing]="'header-section-title'">{{ title() }}</h3></div>
    <div #controlsRef class="-controls aix-toolbar" [hidden]="!controlsRef?.childNodes?.length">
        <ng-content></ng-content>
    </div>
</div>
